<template>
  <div>
    <v-alert color="primary" outlined dismissible>
      Esta é a pagina da sua empresa. Ela fica disponível para todos os clientes
      <b>compradores</b> e contém informações importantes, como dados cadastrais, avaliações,
      score Proxpect, entre outras.
      Estamos trabalho para permitir que você personalize esta página, do seu jeito.
    </v-alert>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && fornecedor">
      <px-minha-pagina-header :fornecedor="fornecedor"/>
      <px-minha-pagina-detalhes class="mt-3" :fornecedor="fornecedor"/>
    </div>
  </div>
</template>

<script>
import MinhaPaginaHeader from './MinhaPaginaHeader.vue';
import MinhaPaginaDetalhes from './MinhaPaginaDetalhes.vue';
import MinhaPaginaService from './minha-pagina-service';

export default {
  data() {
    return {
      loading: false,
      fornecedor: null,
    };
  },
  methods: {
    getVisualizacao() {
      this.loading = true;
      MinhaPaginaService.get()
        .then(({ data }) => {
          this.fornecedor = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getVisualizacao();
  },
  components: {
    pxMinhaPaginaHeader: MinhaPaginaHeader,
    pxMinhaPaginaDetalhes: MinhaPaginaDetalhes,
  },
};
</script>
